// extracted by mini-css-extract-plugin
export default {"cta":"BF-z","disabled":"CF-z"};